var api = process.env.VUE_APP_BUILD_TYPE === 'pro' ? "".concat(location.origin, "/cpscc") : process.env.VUE_APP_API;
var api2 = process.env.VUE_APP_BUILD_TYPE === 'pro' ? process.env.VUE_APP_CPSC_API : process.env.VUE_APP_API2;
var api3 = process.env.VUE_APP_BUILD_TYPE === 'pro' ? "".concat(location.origin, "/cpscc_core") : process.env.VUE_APP_API3;
export { api, api2, api3 };